import { render, staticRenderFns } from "./AddJobReports.vue?vue&type=template&id=508e3536&scoped=true"
import script from "./AddJobReports.vue?vue&type=script&lang=js"
export * from "./AddJobReports.vue?vue&type=script&lang=js"
import style0 from "./AddJobReports.vue?vue&type=style&index=0&id=508e3536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e3536",
  null
  
)

export default component.exports